import { keyframes } from '@emotion/core';
import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

import { staticPath } from '~/renderer/utils';

const playSaleCompletedAnimation = keyframes`
  from {
    background-position: 0;
  }
  to {
    background-position: -2200px;
  }
`;

export const SaleCompletedWrapper = styled('div')`
  display: flex;
  flex-grow: 1;
  justify-content: center;
  background-color: ${themeGet('colors.white')};
  padding: ${themeGet('space.4')};
`;

export const SaleCompletedContainer = styled('div')`
  align-self: center;
  text-align: center;
`;

export const SaleCompletedAnimation = styled('div')`
  background: url('${staticPath}/assets/animated-success.png') center no-repeat;
  height: 88px;
  width: 88px;

  animation: ${playSaleCompletedAnimation} 0.8s steps(25) 1;
  animation-fill-mode: forwards;
`;
